'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var seperate = exports.seperate = function seperate(n, d) {
  return Math.abs(n).toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var currency = exports.currency = function currency(n) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var negative = n < 0;
  var number = seperate(n, d);
  return negative ? '($' + number + ')' : '$' + number;
};

var rate = exports.rate = function rate(n) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var negative = n < 0;
  var number = seperate(n, d);
  return negative ? '(' + number + '%)' : number + '%';
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/numbers.js